export const MESSAGE_DELAY = 400;

export const FUNNEL_TITLE_FALLBACK: { [lang: string]: string } = {
  en: 'Quick Conversation – [Company Name]',
  de: 'Kurzes Gespräch – [Company Name]',
  fr: 'Conversation rapide – [Company Name]',
  it: 'Conversazione rapida – [Company Name]',
};

export const FUNNEL_DESCRIPTION_FALLBACK: { [lang: string]: string } = {
  en: 'Share your experience and get personalised support in just a few minutes. We may ask for feedback, offer recommendations, or connect you with the right next step.',
  de: 'Teilen Sie Ihre Erfahrung und erhalten Sie in wenigen Minuten persönliche Unterstützung. Wir können nach Feedback fragen, Empfehlungen geben oder Sie mit dem nächsten Schritt verbinden.',
  fr: 'Partagez votre expérience et obtenez un accompagnement personnalisé en quelques minutes. Nous pouvons vous demander un retour, vous proposer des recommandations ou vous orienter vers la prochaine étape.',
  it: 'Condividi la tua esperienza e ricevi supporto personalizzato in pochi minuti. Potremmo chiederti un feedback, offrirti consigli o indirizzarti al passo successivo.',
};
